import LearningStyleCommunication from '~/pages/communication/learningStyle/libs/components/LearningStyleCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const LearningStyleCommunicationPage = (props: TPageProps) => (
  <LearningStyleCommunication {...props} />
)

export default LearningStyleCommunicationPage
